import { Endpoint } from '../endpoint';
import {
  ReportModulesResponse,
  ReportModuleId,
  ReportId,
  ReportPageQuery,
  ReportEmailId,
  ReportEmailResponse,
  ReportSettingResponse,
} from '@business/entities/report';
import { R } from '@core/utils/r';

export function fetchModules() {
  return Endpoint.get<ReportModulesResponse[]>(`@gc/report`);
}

export function fetchReport(moduleId: ReportModuleId, reportId: ReportId, params: ReportPageQuery) {
  params = R.omitBy(params, R.isNil);
  return Endpoint.get<any>(`@gc/report/report/${moduleId}.${reportId}`, { params });
}

export function fetchReportEmails(id: ReportId) {
  return Endpoint.get<ReportEmailResponse[]>(`@gc/report/emails/${id}`);
}

export function fetchReportEmail(id: ReportEmailId) {
  return Endpoint.get<ReportEmailResponse>(`@gc/report/email/${id}`);
}

export function createReportEmail(id: ReportId, data: Partial<ReportEmailResponse>) {
  return Endpoint.post<ReportEmailResponse>(`@gc/report/email/${id}`, { data });
}

export function updateReportEmail(id: ReportEmailId, data: Partial<ReportEmailResponse>) {
  return Endpoint.patch<ReportEmailResponse>(`@gc/report/email/${id}`, { data });
}

export function deleteReportEmail(id: ReportEmailId) {
  return Endpoint.delete<void>(`@gc/report/email/${id}`);
}

export function updateReportSettings(id: ReportEmailId, data: Partial<ReportSettingResponse>) {
  return Endpoint.patch<ReportEmailResponse>(`@gc/report/settings/${id}`, { data });
}
